import { h } from 'vue';
import { RouterLink } from 'vue-router';
import _get from 'lodash/get';
import type { BuiTblColumn } from '@/components/bui/organisms/Tbl/types';
import TblThumb from '@/components/bui/atoms/TblThumb/TblThumb.vue';
import TblBadge from '@/components/bui/atoms/TblBadge/TblBadge.vue';
import TblRowActions from '@/components/bui/molecules/TblRowActions/TblRowActions.vue';
import TimeFormatDateOnly from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/TimeFormatDateOnly.vue';
import ImageWithLoadingAndErrorIndicators from '@/components/ImageWithLoadingAndErrorIndicators/ImageWithLoadingAndErrorIndicators.vue';
import SharingLevelsMapping from '@/data/mappings/SharingLevels.map';

const mediaColumns: BuiTblColumn[] = [
  {
    key: 'preview',
    kind: 'preview',
    label: 'Previews',
    /** Room for cell padding + checkbox + gap + 96px thumb (see TblThumb / TblRowCell). */
    width: 176,
    selectable: true,
    render: ({ item }) =>
      h(
        TblThumb,
        {},
        {
          default: () =>
            h(ImageWithLoadingAndErrorIndicators, {
              src: `${item.previewUri}?lastModified=${item.dateLastModified}`,
              imageClass: ['h-full', 'w-full'],
              dateLastModified: item.dateLastModified,
            }),
        },
      ),
  },
  {
    key: 'name',
    kind: 'name',
    label: 'Name',
    grow: true,
    minWidth: 180,
    sortable: true,
    sortKey: 'name',
    render: ({ item }) =>
      h('div', { class: 'bui-cell-name' }, [
        h(
          RouterLink,
          { to: `/media/edit/${item.id}`, class: 'title-link', onClick: (e: MouseEvent) => e.stopPropagation() },
          () => item.name,
        ),
        h('div', { class: 'bui-cell-sub' }, item.assetType ? `${item.assetType[0].toUpperCase()}${item.assetType.substring(1)}` : ''),
      ]),
  },
  {
    key: 'modified',
    kind: 'text',
    label: 'Modified',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'dateLastModified',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.dateLastModified }),
  },
  {
    key: 'created',
    kind: 'text',
    label: 'Created',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'dateCreated',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.dateCreated }),
  },
  {
    key: 'createdBy',
    kind: 'text',
    label: 'Created by',
    grow: true,
    minWidth: 120,
    render: ({ item }) => _get(item, 'createdBy.group.name', 'None'),
  },
  {
    key: 'sharing',
    kind: 'tags',
    label: 'Sharing',
    width: 140,
    render: ({ item }) =>
      h(TblBadge, { tone: 'tag' }, () =>
        (SharingLevelsMapping as Record<number, string>)[item.sharingLevel] || '—',
      ),
  },
  {
    key: 'actions',
    kind: 'actions',
    label: 'Actions',
    width: 100,
    render: ({ item }) => h(TblRowActions, { item }),
  },
];

export default mediaColumns;
